import type { ComponentDefinition, SystemNode } from "./types";

/** A schema migration and several modules match this literal, not the catalog entry. */
export const JUNCTION_DEFINITION_ID = "junction";

/** Not a type predicate on purpose: `false` would then exclude `ComponentNode`
 *  from the union at every call site. */
export function isJunction(
  node: SystemNode | undefined | null,
  def?: ComponentDefinition,
): boolean {
  if (!node || node.kind !== "component") return false;
  if (node.definitionId === JUNCTION_DEFINITION_ID) return true;
  return def?.renderVariant === "junction";
}
